import { productActionTypes } from '@Actions/productActions';

const ProductReducer = (state = {}, action) => {
  switch (action.type) {
  case productActionTypes.GET_PRODUCT_BY_ID.LOADING: {
    const { getProductByIdLoading } = action;
    return {
      ...state,
      getProductByIdLoading,
    };
  }
  case productActionTypes.GET_PRODUCT_BY_ID.SUCCESS: {
    const { selectedProduct } = action;
    return {
      ...state,
      selectedProduct,
    };
  }
  case productActionTypes.SEARCH_PRODUCTS.LOADING: {
    const { searchProductsLoading, isAdvanceProductSearch } = action;
    if (isAdvanceProductSearch) {
      return {
        ...state,
        advanceSearchProductsLoading: searchProductsLoading,
      };
    }
    return {
      ...state,
      searchProductsLoading,
    };
  }
  case productActionTypes.SEARCH_PRODUCTS.SUCCESS: {
    const { searchResults, isAdvanceProductSearch } = action;
    if (isAdvanceProductSearch) {
      return {
        ...state,
        advanceSearchResults: searchResults,
      };
    }
    return {
      ...state,
      searchResults,
    };
  }
  case productActionTypes.SEARCH_BY_REFERENCE_ID.LOADING: {
    const { searchByReferenceIdLoading } = action;
    return {
      ...state,
      searchByReferenceIdLoading,
    };
  }
  case productActionTypes.SEARCH_BY_REFERENCE_ID.SUCCESS: {
    const { searchByReferenceIdResults } = action;
    return {
      ...state,
      searchByReferenceIdResults,
    };
  }
  case productActionTypes.GET_PRODUCTS.LOADING: {
    const { getProductsLoading } = action;
    return {
      ...state,
      getProductsLoading,
    };
  }
  case productActionTypes.GET_PRODUCTS.SUCCESS: {
    const { products } = action;
    if (action.forOffers) {
      return {
        ...state,
        orgProductsForOffers: products,
      };
    }
    return {
      ...state,
      products,
    };
  }
  case productActionTypes.GET_LOW_ORG_PRODUCTS.LOADING: {
    const { getLowOrgProductsLoading } = action;
    return {
      ...state,
      getLowOrgProductsLoading,
    };
  }
  case productActionTypes.GET_LOW_ORG_PRODUCTS.SUCCESS: {
    const { lowOrgProducts } = action;
    return {
      ...state,
      lowOrgProducts,
    };
  }
  case productActionTypes.ADD_PRODUCT_VENDOR.LOADING: {
    const { addProductVendorLoading } = action;
    return {
      ...state,
      addProductVendorLoading,
    };
  }
  case productActionTypes.ADD_PRODUCT_TO_INV.LOADING: {
    const { addProductToInventoryLoading } = action;
    return {
      ...state,
      addProductToInventoryLoading,
    };
  }
  case productActionTypes.UPDATE_PRODUCT_TO_INV.LOADING: {
    const { updateProductToInventoryLoading } = action;
    return {
      ...state,
      updateProductToInventoryLoading,
    };
  }
  case productActionTypes.CREATE_INDENT.LOADING: {
    const { createIndentLoading } = action;
    return {
      ...state,
      createIndentLoading,
    };
  }
  case productActionTypes.UPDATE_INDENT.LOADING: {
    const { updateIndentLoading } = action;
    return {
      ...state,
      updateIndentLoading,
    };
  }
  case productActionTypes.UPDATE_INDENT_STATUS.LOADING: {
    const { updateIndentStatusLoading } = action;
    return {
      ...state,
      updateIndentStatusLoading,
    };
  }
  case productActionTypes.GET_INDENT.LOADING: {
    const { getIndentLoading } = action;
    return {
      ...state,
      getIndentLoading,
    };
  }
  case productActionTypes.GET_INDENT.SUCCESS: {
    const { indents } = action;
    return {
      ...state,
      indents,
    };
  }
  case productActionTypes.SET_DEFAULT_OFFER.LOADING: {
    const { setDefaultOfferLoading } = action;
    return {
      ...state,
      setDefaultOfferLoading,
    };
  }
  case productActionTypes.GET_PRODUCT_OFFERS.LOADING: {
    const { getProductOffersLoading } = action;
    return {
      ...state,
      getProductOffersLoading,
    };
  }
  case productActionTypes.GET_PRODUCT_OFFERS.SUCCESS: {
    const { productOffers } = action;
    return {
      ...state,
      productOffers,
    };
  }
  case productActionTypes.GET_SELLER_PRODUCTS.LOADING: {
    const { getSellerProductsLoading } = action;
    return {
      ...state,
      getSellerProductsLoading,
    };
  }
  case productActionTypes.GET_SELLER_PRODUCTS.SUCCESS: {
    const { sellerProducts } = action;
    return {
      ...state,
      sellerProducts,
    };
  }
  case productActionTypes.GET_INDENT_BY_ID.LOADING: {
    const { getIndentByIdLoading } = action;
    return {
      ...state,
      getIndentByIdLoading,
    };
  }
  case productActionTypes.GET_INDENT_BY_ID.SUCCESS: {
    const { selectedIndent } = action;
    return {
      ...state,
      selectedIndent,
    };
  }
  case productActionTypes.GET_ORG_PRODUCTS.LOADING: {
    const { getOrgProductsLoading } = action;
    return {
      ...state,
      getOrgProductsLoading,
    };
  }
  case productActionTypes.GET_ORG_PRODUCTS.SUCCESS: {
    const { orgProducts } = action;
    return {
      ...state,
      orgProducts,
    };
  }
  case productActionTypes.DELETE_INDENT.LOADING: {
    const { deleteIndentLoading } = action;
    return {
      ...state,
      deleteIndentLoading,
    };
  }
  case productActionTypes.GET_ORG_PRODUCT_BY_ID.LOADING: {
    const { getOrgProductByIdLoading } = action;
    return {
      ...state,
      getOrgProductByIdLoading,
    };
  }
  case productActionTypes.GET_ORG_PRODUCT_BY_ID.SUCCESS: {
    const { selectedOrgProduct } = action;
    return {
      ...state,
      selectedOrgProduct,
    };
  }
  case productActionTypes.GET_RECENT_TRANSACTIONS.LOADING: {
    const { getRecentTransactionsLoading } = action;
    return {
      ...state,
      getRecentTransactionsLoading,
    };
  }
  case productActionTypes.GET_RECENT_TRANSACTIONS.SUCCESS: {
    const { recentTransactions } = action;
    return {
      ...state,
      recentTransactions,
    };
  }
  case productActionTypes.GET_INVENTORY_LOGS.LOADING: {
    const { getInventoryLogsLoading } = action;
    return {
      ...state,
      getInventoryLogsLoading,
    };
  }
  case productActionTypes.GET_INVENTORY_LOGS.SUCCESS: {
    const { inventoryLogs } = action;
    return {
      ...state,
      inventoryLogs,
    };
  }
  case productActionTypes.GET_PRODUCT_BY_SKUS.LOADING: {
    const { getProductBySkusLoading } = action;
    return {
      ...state,
      getProductBySkusLoading,
    };
  }
  case productActionTypes.GET_PRODUCT_BY_SKUS.SUCCESS: {
    const { selectedProductsSkuCode } = action;
    return {
      ...state,
      selectedProductsSkuCode,
    };
  }
  case productActionTypes.GET_SELLER_CODES.LOADING: {
    const { getSellerCodesLoading } = action;
    return {
      ...state,
      getSellerCodesLoading,
    };
  }
  case productActionTypes.GET_SELLER_CODES.SUCCESS: {
    const { getSellerCodesSuccess } = action;
    return {
      ...state,
      getSellerCodesSuccess,
    };
  }
  case productActionTypes.PRINT_BARCODE.LOADING: {
    const { printBarcodesLoading } = action;
    return {
      ...state,
      printBarcodesLoading,
    };
  }
  case productActionTypes.PRINT_BARCODE.SUCCESS: {
    const { printedBarcodes } = action;
    return {
      ...state,
      printedBarcodes,
    };
  }
  case productActionTypes.UPDATE_SA_WORKFLOW_STEP.LOADING: {
    const { updateSAWorkflowStepLoading } = action;
    return {
      ...state,
      updateSAWorkflowStepLoading,
    };
  }
  case productActionTypes.DOWNLOAD_PRODUCT_BATCHES_LIST.LOADING: {
    const { downloadProductBatchesListLoading } = action;
    return {
      ...state,
      downloadProductBatchesListLoading,
    };
  }
  case productActionTypes.DOWNLOAD_INVENTORY_LOGS.LOADING: {
    const { downloadInventoryLogsLoading } = action;
    return {
      ...state,
      downloadInventoryLogsLoading,
    };
  }
  case productActionTypes.BULK_UPDATE_PRODUCTS.LOADING: {
    const { bulkUpdateProductsLoading } = action;
    return {
      ...state,
      bulkUpdateProductsLoading,
    };
  }
  case productActionTypes.GET_BULK_UPLOAD_META_DATA.LOADING: {
    const { getBulkUploadMetadataLoading } = action;
    return {
      ...state,
      getBulkUploadMetadataLoading,
    };
  }
  case productActionTypes.GET_BULK_UPLOAD_META_DATA.SUCCESS: {
    const { bulkUploadMetadata } = action;
    return {
      ...state,
      bulkUploadMetadata,
    };
  }
  case productActionTypes.BULK_UPLOAD_PRODUCT.LOADING: {
    const { bulkUploadProductsLoading } = action;
    return {
      ...state,
      bulkUploadProductsLoading,
    };
  }
  case productActionTypes.BULK_UPLOAD_PRODUCT.SUCCESS: {
    const { bulkUploadResponse } = action;
    return {
      ...state,
      bulkUploadResponse,
    };
  }
  case productActionTypes.BULK_UPLOAD_PRODUCT.ERROR: {
    const { bulkUploadError } = action;
    return {
      ...state,
      bulkUploadError,
    };
  }
  case productActionTypes.PRODUCTS_BULK_UPDATE.LOADING: {
    const { productsBulkUpdateLoading } = action;
    return {
      ...state,
      productsBulkUpdateLoading,
    };
  }
  case productActionTypes.PRODUCTS_BULK_UPDATE.SUCCESS: {
    const { bulkUpdateResponse } = action;
    return {
      ...state,
      bulkUpdateResponse,
    };
  }
  case productActionTypes.PRODUCTS_BULK_UPDATE.ERROR: {
    const { bulkUpdateError } = action;
    return {
      ...state,
      bulkUpdateError,
    };
  }
  case productActionTypes.GET_TALLY_PRODUCTS.LOADING: {
    const { getTallyProductsLoading } = action;
    return {
      ...state,
      getTallyProductsLoading,
    };
  }
  case productActionTypes.GET_TALLY_PRODUCTS.SUCCESS: {
    const { tallyProducts } = action;
    return {
      ...state,
      tallyProducts,
    };
  }
  default: {
    return state;
  }
  }
};

export default ProductReducer;
